var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vs-input", {
    attrs: { type: "number", step: "0.1", placeholder: "0.00" },
    on: { input: _vm.onInput },
    model: {
      value: _vm.rate,
      callback: function ($$v) {
        _vm.rate = $$v
      },
      expression: "rate",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }